import { Loader2 } from "lucide-react";

import { cn } from "@/lib/utils";

export interface CenteredLoaderProps {
  label?: string;
  className?: string;
  iconClassName?: string;
}

export function CenteredLoader({ label, className, iconClassName }: CenteredLoaderProps) {
  return (
    <div
      className={cn(
        "flex min-h-[60vh] items-center justify-center gap-2 text-sm text-muted-foreground",
        className,
      )}
    >
      <Loader2 className={cn("h-5 w-5 animate-spin", iconClassName)} aria-hidden="true" />
      {label ? <span>{label}</span> : null}
    </div>
  );
}
